import React, { useContext } from 'react';

import Portal from 'utility/Bind/Portal/Portal';
import { ConditionalWrapper } from 'utility/Check/ConditionalWrapper';
import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { LoginTheme } from '../types';

import Section from './__partials/Section';
import { PORTAL_LOGIN_BANNER } from './constants';

interface BannerProps {
    theme?: LoginTheme;
    isPortal?: boolean;
}

const Banner = ({ theme, isPortal = false }: BannerProps) => {
    const { components } = useContext(CommunicationContext);
    const isUserLoggedIn =
        components.backendInformationFunc.getSsoData().hasLogin;

    if (isUserLoggedIn) {
        return null;
    }

    return (
        <ConditionalWrapper
            condition={isPortal}
            wrapper={(children: React.ReactElement) => (
                <Portal root={PORTAL_LOGIN_BANNER}>{children}</Portal>
            )}
        >
            <Section theme={theme} />
        </ConditionalWrapper>
    );
};

export default Banner;
